import { createSlice } from '@reduxjs/toolkit'
import { DummyBot } from '@/api/dummyBot'
import { fetchDummyBotsThunk } from '@/redux/asyncThunks/dummyBot'
import { RootState } from '@/redux/store'

interface DummyBotState {
  bots: DummyBot[]
  loading: boolean
  error: string | null
}

const initialState: DummyBotState = {
  bots: [],
  loading: false,
  error: null,
}

const dummyBotSlice = createSlice({
  name: 'dummyBot',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchDummyBotsThunk.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchDummyBotsThunk.fulfilled, (state, action) => {
        state.loading = false
        state.bots = action.payload
      })
      .addCase(fetchDummyBotsThunk.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload as string
      })
  },
})

export default dummyBotSlice.reducer
export const selectDummyBots = (state: RootState) => state.dummyBot.bots
export const selectDummyBotsLoading = (state: RootState) =>
  state.dummyBot.loading
